import styled from 'styled-components';

export const ScoreboardWrap = styled.div`
  grid-area: scoreboard;
  /* Container queries let us swap team abbreviation ↔ full name depending on
     how much horizontal space the Scoreboard card actually has. */
  container-type: inline-size;

  /* This card's body is just a grid — remove the header/body divider. */
  article > header {
    border-bottom: none;
  }

  /* Remove CardBody's ContentWrapper top padding so the grid hugs the header. */
  article > div > div {
    padding-top: 0;
  }

  /* Card fills the grid cell so the grid has the whole right-column width. */
  article {
    width: 100%;
  }

  /* Default: show short team abbreviation. Swap to full name when the card
     is wide enough to comfortably fit it. */
  .team-full {
    display: none;
  }
  @container (min-width: 520px) {
    .team-abbrev {
      display: none;
    }
    .team-full {
      display: inline;
    }
  }

  /* AG Grid floors the auto-height rows section at 150px via
     .ag-center-cols-viewport. The scoreboard only has two rows so override
     it to unset so the card shrinks to fit its content instead of leaving
     a gap. Mirrors the same technique used for detail grids in
     StatGrid.styles.js. */
  .ag-center-cols-viewport {
    min-height: unset !important;
  }

  /* The card's outer border closes the table, so the last row needs no line
     of its own. The shared theme only skips it for rows it can see as last. */
  .ag-row:last-child {
    border-bottom-color: transparent;
  }

  /* Emphasise the Final column values (the shared StatGrid theme handles row
     surfaces and dividers). */
  .ag-cell.scoreboard-final {
    font-weight: ${({ theme }) => theme.typography.headingLarge.fontWeight};
    text-align: right;
    justify-content: flex-end;
  }
`;
